import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React, { type JSX } from 'react';
import { withRouter } from 'react-router';
import constants from '../../common/constants';
import RouterPaths from '../../common/RouterPaths';
import { withAppContext } from '../../contexts/AppContext';
import BrowserHistory from '../utils/BrowserHistory';
import PublishingControls from './action-controls/PublishingControls';
import ContentViewer from './ContentViewer';
import { Container, Header, Box, Button } from '@amzn/awsui-components-core';
import { ShowAllCommentsButton } from '../inline-comment';

class PublisherContentViewer extends ContentViewer {
  protected isEditingAllowed = true;
  protected showPublicationHistory = true;
  protected showSectionalComments = true;
  protected showLastBarRaiserEvaluation: boolean = true;

  protected showReviewFeedback = () => {
    return true;
  };

  protected showContentControls = () => {
    const { workflow } = this.state;
    return ![
      WorkflowState.IN_REVIEW,
      WorkflowState.REVIEWED,
      WorkflowState.PENDING_REVIEW,
      // @ts-expect-error TS18048 - strict migration
    ].includes(workflow.draftState);
  };

  // @ts-expect-error TS2416 - strict migration
  protected renderActions = () => {
    return (
      <Container header={<Header variant="h3">Actions</Header>}>
        <Box padding={{ top: 's' }}>
          <ShowAllCommentsButton handleShowAllComments={this.handleShowAllComments} />
        </Box>
      </Container>
    );
  };

  protected renderControls(): false | JSX.Element {
    const { workflow } = this.state;
    const disabled =
      !!workflow && (!!workflow.lock || workflow.draftState !== WorkflowState.REVIEWED);
    return (
      <PublishingControls
        // @ts-expect-error TS18048 - strict migration
        contentId={workflow.contentId}
        workflow={workflow}
        onActionSuccess={this.navigateToMyPendingPublications}
        disabled={disabled}
      />
    );
  }

  // overrides method in WorkflowView
  protected getBreadcrumbItems(): Array<{ text: string; href: string }> {
    return [
      {
        href: this.props.location.state?.navigateBackTo || RouterPaths.HOME_PAGE,
        text: constants.PUBLISHER_CONTENTS_HEADER,
      },
    ];
  }

  private handleShowAllComments = () => {
    this.setShowInlineCommentsInPublisherPage(true);
  };

  private navigateToMyPendingPublications = async () => {
    const navigateBackTo = this.props.location.state?.navigateBackTo || RouterPaths.HOME_PAGE;
    BrowserHistory.push(navigateBackTo, { keepFlashbarMessages: true });
  };
}

export default withRouter(withAppContext(PublisherContentViewer));
